import { render, staticRenderFns } from "./InvestmentDetailsDialog.vue?vue&type=template&id=312a53c0&scoped=true"
import script from "./InvestmentDetailsDialog.vue?vue&type=script&lang=js"
export * from "./InvestmentDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./InvestmentDetailsDialog.vue?vue&type=style&index=0&id=312a53c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a53c0",
  null
  
)

export default component.exports